import { render, staticRenderFns } from "./Weblogs.vue?vue&type=template&id=54965762&scoped=true"
import script from "./Weblogs.vue?vue&type=script&lang=js"
export * from "./Weblogs.vue?vue&type=script&lang=js"
import style0 from "./Weblogs.vue?vue&type=style&index=0&id=54965762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54965762",
  null
  
)

export default component.exports